module.exports = __webpack_public_path__ + "static/img/labourservicesBJ.467c444.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/labourservicesBJ.png
// module id = g04w
// module chunks = 1